/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckWalletProofDto,
  WalletControllerCheckProof201,
  WalletControllerCheckProof429,
  WalletControllerGeneratePayload201,
  WalletControllerGeneratePayload429,
  WalletControllerGetWallets429,
  WalletDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Generates a one-time Collected Payload string for TonConnect v2 authentication.
 * @summary Generate TonConnect proof payload
 */
export const walletControllerGeneratePayload = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<WalletControllerGeneratePayload201>(
      {url: `/wallet/generate-payload`, method: 'POST', signal
    },
      options);
    }
  


export const getWalletControllerGeneratePayloadMutationOptions = <TError = null | WalletControllerGeneratePayload429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walletControllerGeneratePayload>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof walletControllerGeneratePayload>>, TError,void, TContext> => {

const mutationKey = ['walletControllerGeneratePayload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof walletControllerGeneratePayload>>, void> = () => {
          

          return  walletControllerGeneratePayload(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WalletControllerGeneratePayloadMutationResult = NonNullable<Awaited<ReturnType<typeof walletControllerGeneratePayload>>>
    
    export type WalletControllerGeneratePayloadMutationError = null | WalletControllerGeneratePayload429

    /**
 * @summary Generate TonConnect proof payload
 */
export const useWalletControllerGeneratePayload = <TError = null | WalletControllerGeneratePayload429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walletControllerGeneratePayload>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof walletControllerGeneratePayload>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getWalletControllerGeneratePayloadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Verifies the TonConnect proof (ton_proof v2) and links the authenticated user to their wallet address.
 * @summary Verify TonConnect proof and link wallet
 */
export const walletControllerCheckProof = (
    checkWalletProofDto: CheckWalletProofDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<WalletControllerCheckProof201>(
      {url: `/wallet/check-proof`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkWalletProofDto, signal
    },
      options);
    }
  


export const getWalletControllerCheckProofMutationOptions = <TError = null | null | WalletControllerCheckProof429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walletControllerCheckProof>>, TError,{data: CheckWalletProofDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof walletControllerCheckProof>>, TError,{data: CheckWalletProofDto}, TContext> => {

const mutationKey = ['walletControllerCheckProof'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof walletControllerCheckProof>>, {data: CheckWalletProofDto}> = (props) => {
          const {data} = props ?? {};

          return  walletControllerCheckProof(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WalletControllerCheckProofMutationResult = NonNullable<Awaited<ReturnType<typeof walletControllerCheckProof>>>
    export type WalletControllerCheckProofMutationBody = CheckWalletProofDto
    export type WalletControllerCheckProofMutationError = null | null | WalletControllerCheckProof429

    /**
 * @summary Verify TonConnect proof and link wallet
 */
export const useWalletControllerCheckProof = <TError = null | null | WalletControllerCheckProof429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walletControllerCheckProof>>, TError,{data: CheckWalletProofDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof walletControllerCheckProof>>,
        TError,
        {data: CheckWalletProofDto},
        TContext
      > => {

      const mutationOptions = getWalletControllerCheckProofMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns all TON wallets linked to the authenticated user, ordered by activation time (newest first). The active wallet (used for donations) is marked with isActive: true.
 * @summary Get user wallets
 */
export const walletControllerGetWallets = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<WalletDto[]>(
      {url: `/wallet`, method: 'GET', signal
    },
      options);
    }
  

export const getWalletControllerGetWalletsQueryKey = () => {
    return [`/wallet`] as const;
    }

    
export const getWalletControllerGetWalletsQueryOptions = <TData = Awaited<ReturnType<typeof walletControllerGetWallets>>, TError = null | WalletControllerGetWallets429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWalletControllerGetWalletsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof walletControllerGetWallets>>> = ({ signal }) => walletControllerGetWallets(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WalletControllerGetWalletsQueryResult = NonNullable<Awaited<ReturnType<typeof walletControllerGetWallets>>>
export type WalletControllerGetWalletsQueryError = null | WalletControllerGetWallets429


export function useWalletControllerGetWallets<TData = Awaited<ReturnType<typeof walletControllerGetWallets>>, TError = null | WalletControllerGetWallets429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletControllerGetWallets>>,
          TError,
          Awaited<ReturnType<typeof walletControllerGetWallets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWalletControllerGetWallets<TData = Awaited<ReturnType<typeof walletControllerGetWallets>>, TError = null | WalletControllerGetWallets429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletControllerGetWallets>>,
          TError,
          Awaited<ReturnType<typeof walletControllerGetWallets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWalletControllerGetWallets<TData = Awaited<ReturnType<typeof walletControllerGetWallets>>, TError = null | WalletControllerGetWallets429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user wallets
 */

export function useWalletControllerGetWallets<TData = Awaited<ReturnType<typeof walletControllerGetWallets>>, TError = null | WalletControllerGetWallets429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof walletControllerGetWallets>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWalletControllerGetWalletsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



